import React from "react";
import { styled } from "goober";

import MenuCategory from "@/app/AppShellMenuCategory.jsx";
import type { MenuListItemProps } from "@/app/AppShellMenuListItem.jsx";
import MenuListItem from "@/app/AppShellMenuListItem.jsx";
import { classNames } from "@/util/class-names.mjs";

const Wrapper = styled("div")`
  display: block;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--sp-0_5);

  padding: var(--sp-1);

  .has-category .link {
    padding: var(--sp-1) var(--sp-4);
  }
`;

export default function SingleMenu({
  className,
  menu,
}: {
  className?: string;

  menu: {
    category?: Translation;

    items?: MenuListItemProps[];
  };
}) {
  const { category, items } = menu;

  return (
    <Wrapper className={className}>
      {category && <MenuCategory text={category} />}

      <ul>
        {items?.map((item, key) => (
          <MenuListItem
            key={key}
            {...item}
            {...classNames("type-callout", !!category && "has-category")}
          />
        ))}
      </ul>
    </Wrapper>
  );
}
